import React, { useState } from 'react';
import {
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Box,
    Modal,
    FormHelperText
} from '@mui/material';

import config from '../../config';
import { useEffect } from 'react';
import { notifyError, notifySuccess } from '../../util';
import { translate } from '../../i18n/customI18nProvider';

import { useNotify } from 'react-admin';
import { addBarPossibleDeposits, removeBarPossibleDeposits, swapBarPossibleDeposits } from '../../services/bar.service';
import { Close, Delete, Save } from '@mui/icons-material';

const DepositForm = ({ currencyCode, show, deposit, deposits, selectedDeposits, onClose, barId }) => {
    const notify = useNotify();
    const [depositId, setDepositId] = useState(deposit ? deposit.id : '');
    const [errors, setErrors] = useState({});
    
    useEffect(() => {
        if (deposit) {
            setDepositId(deposit.id);
        } else {
            setDepositId('');
        }
    }, [show]);
    
    const handleChange = (value) => {
        setDepositId(value);
    };
    
    const confirmForm = () => {
        let hasError = false;
        let newErrors = {};
        
        if (!depositId || depositId.trim() === '') {
            newErrors.deposit = translate('custom.errors.required_field');
            hasError = true;
        }
        
        setErrors(newErrors);
        
        return !hasError
    }
    
    const handleSave = async (e) => {
        if (!confirmForm()) return;
        let response;
        if (deposit) {
            response = await swapBarPossibleDeposits(barId, { old_deposit_id: deposit.id, new_deposit_id: depositId });
        } else {
            response = await addBarPossibleDeposits(barId, { deposit_id: depositId });
        }
        if (response.error) {
            notifyError(response.error.error);
        } else {
            notifySuccess('custom.saved_successfully');
        }
        onClose();
    };
    
    const availableDeposits = () => {
        const available = [];
        for(const dep of deposits) {
            let alreadySelected = false;
            for(const id of selectedDeposits) {
                if(dep.id == id) {
                    alreadySelected = true;
                    break;
                }
            }
            if(!alreadySelected || (deposit && dep.id == deposit.id)) {
                available.push(dep);
            }
        }
        return available;
    };
    
    const handleDelete = async () => {
        const response = await removeBarPossibleDeposits(barId, { deposit_id: deposit.id });
        if (response.error) {
            notifyError(notify, response.error.message);
        } else {
            notifySuccess(notify, 'custom.deleted_successfully');
        }
        onClose();
    }
    
    const handleCancel = () => {
        onClose();
    };
    
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 800,
        maxHeight: '80vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2
    };
    
    return (
        <Modal
            open={show}
            onClose={onClose}
            aria-labelledby="possible-deposit-form-title"
            aria-describedby="possible-deposit-form-description"
        >
            <Box sx={modalStyle}>
                <div style={{ width: "100%" }}>
                    <h3 style={{ marginTop: "0px", marginBottom: "30px", width: "100%", borderBottom: "2px solid" + config.baseColor, color: config.baseColor }}>
                        {deposit ? translate('custom.edit_deposit') : translate('custom.add_deposit')}
                    </h3>
                </div>
                
                <Grid container spacing={2}>                
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="standard" error={!!errors.deposit} helpText={errors.deposit}>
                            <InputLabel aria-describedby="deposit-helper-id">{translate('custom.deposit')}</InputLabel>
                            <Select
                                value={depositId}
                                onChange={(e) => handleChange(e.target.value)}
                            >
                                {availableDeposits().map(deposit => (
                                    <MenuItem key={deposit.id} value={deposit.id}>
                                        <p style={{margin: "0px", fontSize: "13px"}}>{deposit.name} {translate('custom.of')} {deposit.price} {currencyCode}</p>
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText id="deposit-helper-id">{ errors.deposit }</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
                
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    {
                        !deposit ? <div></div> :
                        <Button onClick={handleDelete} color="error" variant="outlined" startIcon={<Delete />} 
                            sx={{
                              "& .button-text": {
                                display: { xs: "none", sm: "inline" }
                              },
                              "& .MuiButton-startIcon": {
                                marginRight: { xs: 0, sm: 1 }
                              }
                            }}
                        >
                            <span className='button-text'>{translate('custom.delete')}</span>
                        </Button>
                    }
                    <div style={{display: "flex", gap: 10}}>
                        <Button onClick={handleCancel} variant="outlined" startIcon={<Close />}
                            sx={{
                              "& .button-text": {
                                display: { xs: "none", sm: "inline" }
                              },
                              "& .MuiButton-startIcon": {
                                marginRight: { xs: 0, sm: 1 }
                              }
                            }}
                        >
                            <span className='button-text'>{translate('custom.cancel')}</span>
                            
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSave} startIcon={<Save />}>
                            {translate('custom.save')}
                        </Button>
                    </div>
                </Box>
            </Box>
        </Modal>
    );
};

export default DepositForm;
